import React from "react";
import { FaSearch } from "react-icons/fa";
import "./SearchBar.css";

const SearchBar = ({ search, setSearch, onSearchClick }) => {
  return (
    <div className="user-search-bar">
      <input
        type="text"
        className="user-search-input"
        placeholder="Search ..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div
        className="user-search-icon-right"
        onClick={onSearchClick}
        style={{ cursor: "pointer" }}
      >
        <FaSearch />
      </div>
    </div>
  );
};

export default SearchBar;